export default __webpack_public_path__ + "static/media/basil.27525b4c.png";